import React from 'react';
import List from 'housecall-ui/dist/DesignSystem/DataDisplay/List/List';
import ListItem from 'housecall-ui/dist/DesignSystem/DataDisplay/List/ListItem';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Menu from 'housecall-ui/dist/DesignSystem/Navigation/Menus/Menu';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

import { ListItemProps } from './SearchListItem';
import SearchResults from './SearchResults';

const useStyles = makeStyles(() => ({
  menuContainer: {
    width: 416,
    maxHeight: 800,
  },
}));

export interface SearchResultsProps {
  jobs: ListItemProps[];
  estimates: ListItemProps[];
  customers: ListItemProps[];
  equipment: ListItemProps[];
}

interface SearchResultsContainerProps {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLInputElement | null;
  elementRef: {
    current: HTMLInputElement | HTMLElement | null;
  };
  results: SearchResultsProps;
  loading?: boolean;
  searchTerm?: string;
}

const SearchResultsContainer = ({
  open,
  onClose,
  anchorEl,
  elementRef,
  loading,
  searchTerm,
  results = { jobs: [], estimates: [], customers: [], equipment: [] },
}: SearchResultsContainerProps) => {
  const { menuContainer } = useStyles();

  return (
    <Menu
      disableAutoFocus
      disableEnforceFocus
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      getContentAnchorEl={null}
      version="v2"
      onClick={(e) => {
        if (elementRef?.current && !(e.target as Element).outerHTML?.includes('textarea')) {
          elementRef.current.focus();
        }
      }}
      classes={{ paper: menuContainer }}
    >
      {loading ? (
        <List>
          <ListItem>
            <Grid container spacing={8} justify="center" alignItems="center">
              <Grid item>
                <CircularProgress color="secondary" />
              </Grid>
            </Grid>
          </ListItem>
        </List>
      ) : (
        <SearchResults searchResults={results} searchTerm={searchTerm} />
      )}
    </Menu>
  );
};

export default SearchResultsContainer;
